<template>
  <scout-form
    :is-modified="!!from || !!to"
    label="最終ログイン時期の指定"
  >
    <term-select
      :from="from"
      :to="to"
      no-option
      @update:from="$emit('update:from', $event)"
      @update:to="$emit('update:to', $event)"
    />
    <span class="boss-annotation-text">
      ※アクティブ会員を検索するための項目です（会員登録、ログイン、応募など）
    </span>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import TermSelect from '@/components/atoms/TermSelect'

export default {
  components: {
    ScoutForm,
    TermSelect
  },
  props: {
    from: {
      required: true,
      type: String
    },
    to: {
      required: true,
      type: String
    }
  }
}
</script>
